<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <!-- <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoDetails(0)" v-if="permission.addExpPack">{{
                    permission.addExpPack
                }}</el-button> -->
            </div>
            <div class="search-ctn-right">
                <div class="search-name">平台</div>
                <el-select
                    v-model="searchData.PlatformId"
                    class="search-item"
                    filterable
                    clearable
                    remote
                    size="small"
                    placeholder="请选择"
                    @visible-change="pfVisibleChange($event)"
                >
                    <el-option v-for="item in platformList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                </el-select>
                <div class="search-name">仓库</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.WarehouseId"
                    filterable
                    clearable
                    @visible-change="wHVisibleChange($event)"
                >
                    <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <div class="search-name">组包单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Code" v-filter-special-char="searchData.Code" placeholder="请输入组包单号"></el-input>
                <div class="search-name">销售单号</div>
                <el-input
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.OrderCode"
                    v-filter-special-char="searchData.OrderCode"
                    placeholder="请输入销售单号"
                ></el-input>
                <div class="search-name">状态</div>
                <el-select class="search-item" size="small" v-model="searchData.State">
                    <el-option v-for="item in StateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">组包员</div>
                <el-select
                    v-model="searchData.SId"
                    class="search-item"
                    filterable
                    clearable
                    remote
                    size="small"
                    placeholder="请选择"
                    @visible-change="siVisibleChange($event)"
                >
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name">更新时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn pack-order">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                border
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip label="组包单号" width="180px">
                    <template slot-scope="scope">
                        {{ scope.row.PackingCode }}
                    </template></el-table-column
                >
                <el-table-column show-overflow-tooltip prop="OrderCode" label="关联销售单号">
                    <template slot-scope="scope">
                        <div class="ordercodediv">
                            <div v-for="(item, index) in scope.row.OrderList" :key="index">
                                <el-tag class="codetag" @click="gotoSalesDetails(item.EntpCusOId)">{{ item.OrderCode }}</el-tag>
                                ({{ item.ShopName + ' - ' + item.CusName }})
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="面单图片" width="120px">
                    <template slot-scope="scope">
                        <div class="ordercodediv" v-if="scope.row.ImgUrl">
                            <el-image
                                @click="showMDImgs(downloadUrl + scope.row.ImgUrl)"
                                style="width: 40px; height: 40px"
                                :src="downloadUrl + scope.row.ImgUrl"
                                fit="contain"
                            ></el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="180px" prop="Platform" label="所属电商平台" show-overflow-tooltip></el-table-column>
                <el-table-column width="120px" prop="StoName" label="组包仓库" show-overflow-tooltip></el-table-column>
                <el-table-column width="100px" prop="StateName" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div style="color: red" v-if="scope.row.StateName == '待上传面单'">{{ scope.row.StateName }}</div>
                        <div v-else>{{ scope.row.StateName }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="StaffName" label="组包员" show-overflow-tooltip width="100px"></el-table-column>
                <el-table-column width="160px" prop="CreateTime" label="组包时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="160px" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="Remark" label="备注" show-overflow-tooltip></el-table-column> -->
                <el-table-column label="操作" fixed="right" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.uploadMD" @click="uploadMD(scope.row)" type="text" size="small">{{ permission.uploadMD }}</el-button>
                            <!-- <el-button v-if="permission.editExpPack" @click="gotoDetails(2, scope.row)" type="text" size="small">{{ permission.editExpPack }}</el-button> -->
                            <el-button v-if="permission.delExpPack" @click="del(scope.row)" type="text" size="small" style="color: red">{{
                                permission.delExpPack
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="showDialog" :append-to-body="true" width="1200px">
            <div v-if="showDialog">
                <packSaleList @closeDialog="closeDialog" :PackId="this.packId"></packSaleList>
            </div>
        </el-dialog>
        <input type="file" style="display: none" id="chooseImgBtn" @change="uploadImg" />
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import uploadFile from '../../../assets/js/uploadFile';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import packSaleList from '@/components/business/ecPlatform/packSaleList';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        timePicker,
        breadcrumb,
        ElImageViewer,
        elTableColumn,
        packSaleList
    },
    data() {
        return {
            timeVisible: false,
            multipleSelection: null,
            downloadUrl: this.$util.QN_URL_BASE,
            tableData: [],
            options: [],
            idList: [],
            platformList: [],
            searchData: {
                PlatformId: '',
                WarehouseId:'',
                Code: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            tableDataLength: 0,
            permission: {},
            StateList: [
                { Text: '全部', Value: '' },
                { Text: '待上传面单', Value: '0' },
                { Text: '未打印', Value: '1' },
                { Text: '已打印', Value: '2' }
            ],
            SIdList: [],
            tempPackId: '',
            showViewer: false,
            srcList: [],
            showDialog: false,
            dialogTitle: '',
            packId: '',
            warehouseList:[]
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('ecExpPacks');
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        // 跳转到销售单详情
        gotoSalesDetails(oid) {
            this.$router.push(`/ecPlatform/ecSalesOrder/check?id=${oid}`);
        },
        // 删除组包单
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该快递组包单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpSaleOrder/DeleteExpPacks',
                            data: {
                                Id: row.Id
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        resetSearch() {
            this.searchData = {
                PlatformId: '',
                WarehouseId:'',
                Code: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.searchCustom('');
        },
        // 跳转订单详情
        // gotoDetails(type, item) {
        //     let PLId = item ? item.Id : '';
        //     this.$router.push(`/inventoryManage/packingList/edit?type=${type}&PLId=${PLId}`);
        // },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetEntpExpPackList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].Id);
            }
            this.idList = idList;
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) that.getSIdList();
            }
        },
        handleDBClick(event) {
            if (event) {
                this.packId = event.Id;
                this.dialogTitle = '快递组包【 ' + event.PackingCode + ' 】销售单数据';
                this.showDialog = true;
            }
        },
        closeDialog() {
            this.showDialog = false;
            this.packId = '';
        },
        uploadMD(item) {
            this.tempPackId = item.Id;
            let btn = document.getElementById('chooseImgBtn');
            btn.click();
        },
        // 上传图片
        uploadImg(item) {
            let that = this;
            let userMsg = that.$util.getLocalStorage('userMsg');
            uploadFile({
                id: 'chooseImgBtn', // 上传按钮id
                url: that.$util.BASE_URL + '/UploadFile/UploadSingle',
                type: 'jpg,png,jpeg', // 上传文件的后缀名,用英文逗号隔开
                maxSize: 20 * 1024, // 文件最大大小，单位KB
                progressCtn: '', // 显示进度条的容器id，样式自己写
                nameMaxLen: 80, //名字最长字符数
                token: userMsg.Token,
                data: {
                    // 要带过去的参数
                    key: 'LogisMD',
                    isPrivate: false
                },
                // 上传成功后执行
                success: function (response) {
                    let res = JSON.parse(response);
                    if (res.errcode == 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/UploadPackMDs',
                                data: {
                                    PackId: that.tempPackId,
                                    ImgUrl: res.fileUrl,
                                    ImgName: res.fileName,
                                    ImgExt: res.fileExt
                                }
                            })
                            .then(() => {
                                that.$util.successMsg('上传成功');
                                that.tableData.forEach(d => {
                                    if (that.tempPackId == d.Id) {
                                        d.ImgUrl = res.fileUrl;
                                        return;
                                    }
                                });

                                that.tempPackId = '';
                            })
                            .catch(() => {});
                    } else {
                        that.$util.errorMsg(res.errmsg);
                    }
                }
            });
        },
        getPlatformList() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetPlatformList'
                })
                .then(res => {
                    if (res.data) {
                        that.platformList = res.data;
                    } else {
                        that.platformList = [];
                    }
                });
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    that.$util.getWarehouse(1).then(data => {
                        that.warehouseList = data;
                    });
                }
            }
        },
        pfVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.platformList.length <= 1) that.getPlatformList();
            }
        },
        closeViewer() {
            this.showViewer = false;
        },
        showMDImgs(imgUrl) {
            this.srcList = [];
            this.srcList.push(imgUrl);
            this.showViewer = true;
        }
    }
};
</script>
<style lang="less" scoped>
.ordercodediv {
    display: flex;
    flex-direction: column;
    .codetag {
        font-size: 14px;
        border-style: none none none none;
        background-color: transparent;
        padding: 0;
    }
}
</style>
<style lang="less">
.pack-order {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
    .el-tag {
        height: 14px;
        line-height: 14px;
    }
}
</style>
